import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" }
const _hoisted_2 = { class: "flex items-center justify-between h-16" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "shrink-0" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "h-8 w-8",
    src: "https://tailwindui.com/img/logos/workflow-mark-indigo-500.svg",
    alt: "Workflow"
  })
], -1)
const _hoisted_5 = { class: "hidden md:block" }
const _hoisted_6 = { class: "ml-10 flex items-baseline space-x-4" }
const _hoisted_7 = ["aria-current", "onClick"]
const _hoisted_8 = { class: "hidden md:block" }
const _hoisted_9 = { class: "ml-4 flex items-center md:ml-6" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open user menu", -1)
const _hoisted_11 = ["src"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "-mr-2 flex md:hidden" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open main menu", -1)
const _hoisted_15 = { class: "px-2 pt-2 pb-3 space-y-1 sm:px-3" }
const _hoisted_16 = { class: "pt-4 pb-3 border-t border-gray-700" }
const _hoisted_17 = { class: "flex items-center px-5" }
const _hoisted_18 = { class: "shrink-0" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "ml-3" }
const _hoisted_21 = { class: "text-base font-medium leading-none text-white" }
const _hoisted_22 = { class: "text-sm font-medium leading-none text-gray-400" }
const _hoisted_23 = { class: "mt-3 px-2 space-y-1" }

import { useStore } from '@/store'
import { Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import { MenuIcon, XIcon } from '@heroicons/vue/outline'
import { computed, reactive } from 'vue'
import { useRouter } from 'vue-router'
import * as AuthService from '@/services/AuthService'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()

const loggedIn = computed<boolean>(() => store.getters.isLoggedIn)
const user = computed(() => store.state.auth.user)

const router = useRouter()

const navigation = [
  reactive({
    name: 'Tours',
    isCurrent: computed(() => router.currentRoute.value.name === 'tours' || router.currentRoute.value.name === 'tour-details' || router.currentRoute.value.name === 'day-details'),
    handler: () => router.push('/tours')
  }),
  reactive({
    name: 'Stops',
    isCurrent: computed(() => router.currentRoute.value.name === 'stops' || router.currentRoute.value.name === 'stop-details'),
    handler: () => router.push('/stops')
  }),
  reactive({
    name: 'POIs',
    isCurrent: computed(() => router.currentRoute.value.name === 'pois' || router.currentRoute.value.name === 'poi-details' || router.currentRoute.value.name === 'promo-details'),
    handler: () => router.push('/pois')
  }),
  reactive({
    name: 'News',
    isCurrent: computed(() => router.currentRoute.value.name === 'news'),
    handler: () => router.push('/news')
  }),
  reactive({
    name: 'App Home',
    isCurrent: computed(() => router.currentRoute.value.name === 'app-home'),
    handler: () => router.push('/app-home')
  }),
  reactive({
    name: 'About Us Page',
    isCurrent: computed(() => router.currentRoute.value.name === 'about-us'),
    handler: () => router.push('/about-us')
  }),
  reactive({
    name: 'Users',
    isCurrent: computed(() => router.currentRoute.value.name === 'users'),
    handler: () => router.push('/users')
  })
]
const userNavigation = [
  { name: 'Sign out', handler: () => logout() }
]

async function logout () {
  try {
    await AuthService.logout()
    router.push('/login')
  } catch (error) {
    console.log(error)
  }
}


return (_ctx: any,_cache: any) => {
  return (_unref(loggedIn))
    ? (_openBlock(), _createBlock(_unref(Disclosure), {
        key: 0,
        as: "nav",
        class: "bg-gray-800"
      }, {
        default: _withCtx(({ open }) => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navigation, (item) => {
                      return _createElementVNode("a", {
                        href: "#",
                        key: item.name,
                        class: _normalizeClass([item.isCurrent ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white', 'px-3 py-2 rounded-md text-sm font-medium']),
                        "aria-current": item.isCurrent ? 'page' : undefined,
                        onClick: _withModifiers(item.handler, ["prevent"])
                      }, _toDisplayString(item.name), 11, _hoisted_7)
                    }), 64))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_unref(Menu), {
                    as: "div",
                    class: "ml-3 relative"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(_unref(MenuButton), { class: "max-w-xs bg-gray-800 rounded-full flex items-center text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white" }, {
                          default: _withCtx(() => [
                            _hoisted_10,
                            _createElementVNode("img", {
                              class: "h-8 w-8 rounded-full bg-gray-400",
                              src: _unref(user)?.avatarURL ?? `https://eu.ui-avatars.com/api/?name=${_unref(user)?.firstName + '%20' + _unref(user)?.lastName}`,
                              alt: ""
                            }, null, 8, _hoisted_11)
                          ]),
                          _: 1
                        })
                      ]),
                      _createVNode(_Transition, {
                        "enter-active-class": "transition ease-out duration-100",
                        "enter-from-class": "transform opacity-0 scale-95",
                        "enter-to-class": "transform opacity-100 scale-100",
                        "leave-active-class": "transition ease-in duration-75",
                        "leave-from-class": "transform opacity-100 scale-100",
                        "leave-to-class": "transform opacity-0 scale-95"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(MenuItems), { class: "origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none" }, {
                            default: _withCtx(() => [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(userNavigation, (item) => {
                                return _createVNode(_unref(MenuItem), {
                                  key: item.name
                                }, {
                                  default: _withCtx(({ active }) => [
                                    _createElementVNode("a", {
                                      href: "#",
                                      onClick: _withModifiers(item.handler, ["prevent"]),
                                      class: _normalizeClass([active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700'])
                                    }, _toDisplayString(item.name), 11, _hoisted_12)
                                  ]),
                                  _: 2
                                }, 1024)
                              }), 64))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_unref(DisclosureButton), { class: "bg-gray-800 inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white" }, {
                  default: _withCtx(() => [
                    _hoisted_14,
                    (!open)
                      ? (_openBlock(), _createBlock(_unref(MenuIcon), {
                          key: 0,
                          class: "block h-6 w-6",
                          "aria-hidden": "true"
                        }))
                      : (_openBlock(), _createBlock(_unref(XIcon), {
                          key: 1,
                          class: "block h-6 w-6",
                          "aria-hidden": "true"
                        }))
                  ]),
                  _: 2
                }, 1024)
              ])
            ])
          ]),
          _createVNode(_unref(DisclosurePanel), { class: "md:hidden" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navigation, (item) => {
                  return _createVNode(_unref(DisclosureButton), {
                    key: item.name,
                    as: "a",
                    class: _normalizeClass([item.isCurrent ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white', 'block px-3 py-2 rounded-md text-base font-medium']),
                    "aria-current": item.isCurrent ? 'page' : undefined,
                    onClick: _withModifiers(item.handler, ["prevent"])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["class", "aria-current", "onClick"])
                }), 64))
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("img", {
                      class: "h-10 w-10 rounded-full bg-gray-400",
                      src: _unref(user)?.avatarURL ?? `https://eu.ui-avatars.com/api/?name=${_unref(user)?.firstName + '%20' + _unref(user)?.lastName}`,
                      alt: ""
                    }, null, 8, _hoisted_19)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(user)?.firstName), 1),
                    _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(user)?.email), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(userNavigation, (item) => {
                    return _createVNode(_unref(DisclosureButton), {
                      key: item.name,
                      as: "a",
                      class: "block px-3 py-2 rounded-md text-base font-medium text-gray-400 hover:text-white hover:bg-gray-700",
                      onClick: _withModifiers(item.handler, ["prevent"])
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  }), 64))
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})